// Résout l'URL d'un fichier uploadé (avatar, logo, photo produit).
// - URL absolue (http...) ou data: → renvoyée telle quelle
// - chemin /uploads/... → préfixé par l'origine de l'API (sans /api)
// - sinon → renvoyée telle quelle
export function resolveUploadUrl(url) {
  if (!url) return null;
  if (url.startsWith('http') || url.startsWith('data:')) return url;
  if (url.startsWith('/uploads/')) {
    const base = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api')
      .replace(/\/api\/?$/, '');
    return base + url;
  }
  return url;
}

// Initiales à partir d'un prénom + nom (fallback avatar texte).
export function initiales(prenom, nom) {
  const p = (prenom || '').trim();
  const n = (nom || '').trim();
  const a = p ? p[0] : '';
  const b = n ? n[0] : '';
  const ini = (a + b).toUpperCase();
  return ini || '·';
}
